import styled from 'styled-components';
import Table from 'components/ui/Table';


export const StyledTable = styled(Table)`
 td, th { min-width: 50px; word-break: break-word; text-align: center; }

`;
